import React, { useState, useEffect, useContext } from 'react'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import CheckoutComponent from '../../../utils/CommonFunctionality/Checkout/'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Checkout = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <>
            <SEOTAG page="Checkout" />
            <Layout props={props}>
                {isVarifiedGfTheme ? (
                    <CheckoutComponent props={props} storeTheme="Lotsofauctions" />
                ) : (
                    <>
                        <DashboardHeader />
                        <CheckoutComponent props={props} storeTheme="Lotsofauctions" />
                    </>
                )}
            </Layout>
        </>
    )
}

export default Checkout
